<div class="become-instructor-partner-area">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-content bg-color">
                    <h2>Creare cont C.M.D.T.A.M.P</h2>
                    <p>Pentru a putea beneficia de un cont online pe portalul <strong>www.cmdtamp.ro</strong>, va asteptam in incinta policlinicii noastre din strada Washington 8-10, la biroul Programari, cu buletinul. Ulterior, veti primi din partea departamentul IT un user si o parola pentru a avea acces in sectiunea ACCES MEMBRI.</p>
                    
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-image bg-image1">
                    <img src="assets/img/become-instructor.jpg" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-image bg-image2">
                    <img src="assets/img/become-partner.jpg" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-content">
                    <h2>Analize de Laborator</h2>
                    <h6>PACHETUL DE SERVICII MEDICALE DE BAZĂ ÎN ASISTENŢA MEDICALĂ AMBULATORIE DE SPECIALITATE PENTRU SPECIALITĂŢILE PARACLINICE</h6>
                    <p>Consulta lista investigaţiilor paraclinice - analize de laborator DECONTATE DE OPSNAJ</p>
                    <a routerLink="/specialitati-medicale/laborator" class="default-btn"><i class='bx bx-plus-circle icon-arrow before'></i><span class="label">Detalii</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>